import { jsx as _jsx } from "react/jsx-runtime";
import { formatVerboseHms, parseHmsString } from "../../components/utils/formatTime";
const AverageCompletionTime = ({ avgCompletionTime, className }) => {
    const parts = parseHmsString(avgCompletionTime);
    if (!parts)
        return;
    return _jsx("p", { className: className, children: formatVerboseHms(parts) });
};
export default AverageCompletionTime;
